import Vue from "vue";
import Vuex from "vuex";
import store from "./store/index";
import Accordion from "./components/Accordion.vue";
import PartnersCarousel from "./components/PartnersCarousel.vue";
import { mapFields } from "vuex-map-fields";
import VueTinySlider from 'vue-tiny-slider';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import StatsCounter from "./components/StatsCounter.vue";
import ContinuousScroller from "./components/ContinuousScroller.vue";

gsap.registerPlugin(ScrollTrigger);


/**
 * Set up config
 * **/
function init() {
  
  new Vue({
    el: "#tbl-app",
    data: {
      mainMenuOpen: false,
      childMenuOpenID: 0,
      grandchildMenuActiveID: 0,
      showGlossaryBackToTop: false,
      showAutoloader: false,
    },
    components: {
      accordion: Accordion,
      'partners-carousel': PartnersCarousel,
      'tiny-slider': VueTinySlider,
      'stats-counter': StatsCounter,
      "continuous-slider": ContinuousScroller,
    },
    store,
    mounted() {

      // Add resize listener
      window.addEventListener("resize", this.handleWindowChange);
      window.addEventListener("orientationchange", this.handleWindowChange);

      // Rounded corner element background AND banner
      document.querySelectorAll('.element-bg--radius').forEach(el => {
        const baseEl = el.parentElement;
        const prevEl = baseEl?.previousElementSibling;
        if (!prevEl) return;

        const colourDiv = prevEl.querySelector('[data-colour]');
        if (!colourDiv) return;

        const background = colourDiv.dataset.colour; // dataset is faster and cleaner
        if (background) baseEl.classList.add(`base-colour--${background}`);
      });

      // show autoloader after mount so hide while images load and component sets up
      this.$nextTick(() => {
        this.showAutoloader = true;
      });
      
    },
    beforeUnmount() {
      // Clean up listeners
      window.removeEventListener("resize", this.handleWindowChange);
      window.removeEventListener("orientationchange", this.handleWindowChange);
    },
    computed: {
      ...mapFields([
        "inlineLinkSelected",
        "glossaryItemSelected",
      ]),
    },
    methods: {
      handleWindowChange() {
        this.mainMenuOpen = false;
        this.childMenuOpenID = 0;
        this.grandchildMenuActiveID = 0;
      },

      toggleMainMenu: function () {
        this.mainMenuOpen = !this.mainMenuOpen;
        // if menu closed, close children as well
        if (!this.mainMenuOpen) {
          this.childMenuOpenID = 0;
        }

        // prevent body scroll when menu is open
        document.body.style.overflow = this.mainMenuOpen ? 'hidden' : '';
      },

      toggleChildMenu: function (childMenuOpenID) {
        // check if mobile menu is operating
        // desktop should just do usual link behaviour        
        if (window.innerWidth < 1279) {
          // prevent default link action
          // event.preventDefault();

          // check if we're opening or closing menu
          if (this.childMenuOpenID === childMenuOpenID) {
            // close if is current open
            this.childMenuOpenID = 0;
          } else {
            this.childMenuOpenID = childMenuOpenID;
          }

          // open main menu if not open
          if (!this.mainMenuOpen) {
            this.mainMenuOpen = true;
          }
        }
      },

      toggleGrandchildMenu: function (grandchildMenuActiveID) {
        // this.childMenuActive = !this.childMenuActive;
        // check if we're opening or closing menu
        if (this.grandchildMenuActiveID === grandchildMenuActiveID) {
          // close if is current open
          this.grandchildMenuActiveID = 0;
        } else {
          this.grandchildMenuActiveID = grandchildMenuActiveID;
        }

        // open main menu if not open
        if (!this.mainMenuOpen) {
          this.mainMenuOpen = true;
        }
      },

      childMenuActive(id) {
        if (this.childMenuOpenID === id) {
          return true;
        } else {
          return false;
        }
      },

    }
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});